module.exports = __webpack_public_path__ + "static/media/hero-group.e2e79991.webp";